import { lighten } from '@material-ui/core/styles/colorManipulator';

export const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: '0 0 auto'
  }
});

export const EnhancedTableStyles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    [theme.breakpoints.down('xs')]: {}
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  actionButton: {
    marginLeft: '-15px'
  },
  emptyTable: {
    height: '400px'
  }
});

export const paginationStyles = theme => ({
  paginationRoot: {
    color: theme.palette.text.secondary,
    padding: '10px 5px 10px 5px',
    display: 'flex',
    '& button': {
      padding: '3px'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '20px',
      width: '100%'
    }
  }
});

export const Search = theme => ({
  searchContainer: {
    display: 'flex',
    width: '50%',
    flexWrap: 'wrap',
    margin: '20px 10px 20px 0px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: '20px 0px 20px 0px'
    }
  },
  collapseContainer: {
    width: '100%'
  },
  textField: {
    width: '100%'
  },
  datePickerContainer: {
    width: '48%',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  messageEndDate: {
    width: '100 %',
    paddingLeft: '52%'
  },
  errorMessages: {
    fontSize: '10px',
    color: 'red'
  }
});
